import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import styles from './header-search-bar-suggestions-container.module.scss';
export const HeaderSearchBarSuggestionsContainer = ({ children, displayThreeColumns }) => (_jsx("div", { className: cx(`${styles['header-search-bar-suggestions-container']} p-3`, {
        [styles[`header-search-bar-suggestions-container--three-columns`]]: displayThreeColumns
    }), "data-testid": "redesigned-suggestion-list", children: children }));
